export default class OptAllSystemsInModalController {
  constructor(private modalPromise, private included, private $scope) {
    'ngInject';
  }

  setAllIn() {
    this.$scope.$hide();
    this.modalPromise.resolve();
  }

  cancel() {
    this.$scope.$hide();
    this.modalPromise.reject();
  }
}
